import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'

import { useUserFeatureFlags } from 'global/hooks/useFeatureFlags'

import Modal from 'components/Modal'
import FormCheck from 'components/Form/FormCheck'
import TouchableOpacity from 'components/TouchableOpacity'

import styles from './styles.module.scss'

const FeatureFlagsModal = ({ show, closeModal, userId }) => {
  const {
    flags,
    isLoading,
    isSaving,
    setFlag
  } = useUserFeatureFlags(show ? userId : null)

  const handleToggle = (flagKey, nextValue) => {
    setFlag({ userId, flagKey, enabled: nextValue })
  }

  const handleReset = flagKey => {
    setFlag({ userId, flagKey, enabled: null })
  }

  return (
    <Modal show={show} closeModal={closeModal}>
      <Row>
        <Col xs={12}>
          <div className="mb-20">
            <p className={styles.modalTitle}>Features</p>
            <p className="text-gray-dark">
              Toggle features on or off for this user. Reset to
              return the user to the default state.
            </p>
          </div>

          {isLoading && <p>Loading…</p>}

          {!isLoading && flags.length === 0 && (
            <p>No features available.</p>
          )}

          {!isLoading &&
            flags.map(flag => {
              const isOverridden = flag.override !== null
              return (
                <div
                  key={flag.key}
                  className="pb-15 mb-15 border-bottom"
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="mr-15">
                      <p className="font-weight-bold mb-0">
                        {flag.name}
                      </p>
                      {flag.description && (
                        <p className="text-gray-dark mb-5">
                          {flag.description}
                        </p>
                      )}
                      <p className="text-gray-dark mb-0">
                        Default:{' '}
                        {flag.defaultEnabled ? 'On' : 'Off'}
                        {isOverridden &&
                          ` · Overridden to ${
                            flag.override ? 'On' : 'Off'
                          }`}
                      </p>
                    </div>
                    <div className="d-flex flex-column align-items-end">
                      <FormCheck
                        controlId={`feature-flag-${flag.key}`}
                        label={flag.effective ? 'On' : 'Off'}
                        checked={flag.effective}
                        disabled={isSaving}
                        onChange={e =>
                          handleToggle(
                            flag.key,
                            e.target.checked
                          )
                        }
                      />
                      {isOverridden && (
                        <TouchableOpacity
                          onClick={() => handleReset(flag.key)}
                        >
                          <span className="link">
                            Reset to default
                          </span>
                        </TouchableOpacity>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
        </Col>
      </Row>
    </Modal>
  )
}

FeatureFlagsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
}

export default FeatureFlagsModal
